import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger)

export default class Header {
  constructor (el) {
    this.el = el
    this.burger = document.querySelectorAll('.js-burger')
    this.menu = this.el.querySelector('.js-header-menu')
    this.lastScrollPosition = 0
    this.marker = null

    this.toggleHandler = (e) => this.toggle(e)
    this.scrollHandler = (e) => this.onScroll(e)
    this.resizeHandler = (e) => this.onResize(e)

    this.body = document.body
  }

  init () {
    this.initEvents()
    this.onResize()

    const marker = document.querySelector('.js-show-header')

    if (marker) {
      this.marker = marker
    } else {
      this.el.classList.remove('hidden')
    }
  }

  initEvents () {
    this.burger.forEach(el => {
      el.addEventListener('click', this.toggleHandler)
    })
    window.addEventListener('scroll', this.scrollHandler)
    window.addEventListener('resize', this.resizeHandler)
  }

  removeEvents () {
    this.burger.forEach(el => {
      el.removeEventListener('click', this.toggleHandler)
    })
    window.removeEventListener('scroll', this.scrollHandler)
    window.removeEventListener('resize', this.resizeHandler)
  }

  onResize () {
    if (window.innerWidth < 1025) {
      
    } else {
      this.burger.forEach(el => {
        el.classList.remove('active')
      })
      this.el.classList.remove('open')
      document.body.classList.remove('block-scroll')
    }
  }

  onScroll (e) {

    if (this.marker) {
      
      if (window.scrollY > this.marker.getBoundingClientRect().top + window.scrollY) {
        this.el.classList.remove('hidden')
      } else {
        this.el.classList.add('hidden')
      }

    }

    // if (window.scrollY > 50 && window.scrollY > this.lastScrollPosition) {
    //   this.el.classList.add('collapsed')
    // } else {
    //   this.el.classList.remove('collapsed')
    // }

    this.lastScrollPosition = window.scrollY <= 0 ? 0 : window.scrollY

  }

  toggle (e) {
    e.preventDefault()
    
    if (this.el.classList.contains('open')) {
      
      this.burger.forEach(el => {
        el.classList.remove('active')
      })
      this.el.classList.remove('open')
      document.body.classList.remove('block-scroll')

    } else {
      
      this.burger.forEach(el => {
        el.classList.add('active')
      })
      this.el.classList.add('open')
      document.body.classList.add('block-scroll')

    }
  }

  destroy () {
    this.removeEvents()
  }

}
